/**
 * PKT-0854 · date-only values ("YYYY-MM-DD", from Postgres `date` columns:
 * clients/leads.move_in_date, units.available_date, invoices.due_date /
 * invoice_date — types read from production 2026-09-24) are CALENDAR days, not
 * instants. `new Date("2026-11-01")` parses as UTC midnight, which in US time
 * zones renders as Oct 31 and compares as the evening before. Parse them as
 * LOCAL calendar dates; anything with a time part parses exactly as before.
 * (FloorplanPublicPage.formatDate already did this locally; this is the shared
 * version so the class is fixed, not one instance.)
 */
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseCalendarDate(value: string): Date {
  const m = DATE_ONLY.exec(value);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return new Date(value);
}
